import PageTitle from "../../../layouts/PageTitle";
import React, { useState, useRef, Fragment, useEffect, useCallback  } from "react";
import {
   getCroppedImg,
   UpdateSiteSocials
} from './Requests';
import './Socials.css'
import { ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  notifyError,
  notifySuccess
} from '../Response/ResposeHandler'
import {PulseLoader } from "react-spinners";


const Socials = (props) => {
    const [facebookLink, setFacebookLink] = useState(props.site.facebookLink)
    const [twitterLink, setTwitterLink] = useState(props.site.twitterLink)
    const [instagramLink, setInstagramLink] = useState(props.site.instagramLink)
    const [tiktokLink, setTiktokLink] = useState(props.site.tikTokLink)
    const [linkedInLink, setLinkedInLink] = useState(props.site.linkedInLink)
    const [saveButtonLoading, setSaveButtonLoading] = useState(false)

    function SubmitSocials()
{
    setSaveButtonLoading(true)
    UpdateSiteSocials(facebookLink, instagramLink, twitterLink, tiktokLink, linkedInLink).then((res) => {
        notifySuccess("Section Saved")
    }).catch((error) => {
        notifyError("There was an issue saving this site section, please try again or contact support.")
    }).finally((f) => {
        props.getSite()
        setSaveButtonLoading(false)
    })
}

    return (
    <div>
        <ToastContainer />
        <label style={{marginTop:"1rem"}} htmlFor="site-title">Facebook Link</label>
        <input value={facebookLink} onChange={(e) => {setFacebookLink(e.target.value)}} type="text" id="site-title" placeholder="facebook link"/>
        <label htmlFor="site-title">Twitter Link</label>
        <input value={twitterLink} onChange={(e) => {setTwitterLink(e.target.value)}} type="text" id="site-title" placeholder="twitter link"/>

        <label htmlFor="site-title">Intagram Link</label>
        <input value={instagramLink} onChange={(e) => {setInstagramLink(e.target.value)}} type="text" id="site-title" placeholder="instagram link"/>

        <label htmlFor="site-title">TikTok Link</label>
        <input value={tiktokLink} onChange={(e) => {setTiktokLink(e.target.value)}} type="text" id="site-title" placeholder="tiktok link"/>

        <label htmlFor="site-title">LinkedIn Link</label>
        <input value={linkedInLink} onChange={(e) => {setLinkedInLink(e.target.value)}} type="text" id="site-title" placeholder="LinkedIn link"/>

        <button disabled={saveButtonLoading} onClick={SubmitSocials} style={{marginTop:0, marginTop:"2rem"}} className='save-button button'>
            {!saveButtonLoading ?
            "Save":
            <PulseLoader 
                color={'#eee'}
                loading={saveButtonLoading}
                size={10}
                aria-label="Loading Spinner"
                data-testid="loader"
            />
            }
        </button>
    </div>
    );
}

export default Socials;